/**
 * @Description Fasat Grid Style Component
 * @FileName styleComponents.js
 * @Author ABHISEK KUNDU-kundabh
 * @CreatedOn 03 February, 2021 08:18:24
 * @IssueID -323
 */

import { colors, typography } from '@manulife/mux';
import styled from 'styled-components';
import checkmark from '../../../assets/images/checkmark.png';

export const Wrapper = styled.div`
  width: 100%;
  // margin: 0 auto;
  overflow-x: visible;
  overflow-y: visible;
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #DFE0E2;
  }
  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
    background-color: #DFE0E2;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #8e90a2;
  }
`;

export const TableUtility = styled.div`
  font-family: ${typography.fontFamily};
  border-bottom: 4px solid ${colors.light_grey};
  display: flex;
  justify-content: space-between;
`;

export const Table = styled.table`
  font-family: ${typography.fontFamily};
  text-align: left;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #34384b;
  border-top: solid 4px ${colors.light_grey};
  border-collapse: collapse;
  width: max-content;

  caption {
    position: absolute !important;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
  } 

  tr {
    border-bottom: 2px solid ${colors.light_grey}; 
    &:last-child .actions-col {
        width: 120px !important;
    }  
    th {
      font-weight: 600;
      vertical-align: bottom;
      padding: 8px;
      white-space: pre;
      /* Flex container for header text and sort icons */
      .headerFlex {
        display: flex;
        align-items: center;
      }
      .columnHeaderText {
        word-break: break-word;
        margin-right: 4px;
      }
      .sortIcons {
        width: 24px;
        height: 24px;
        vertical-align: bottom;
        display: inline-flex;
        align-items: center;
      }
      .headerUnbold {
        font-weight: 300;
      }
      /* Make header Actions sticky only when table has action column */
      .hasActionColumn & {
        &:last-child {
          min-width: auto !important;
          position: sticky !important;
          padding-left: 20px;
          right: 0;
          background-color: white;
          border-bottom: 2px solid #EDEDED;
          border-top: 4px solid #EDEDED;
          margin-top: -4px;
          box-shadow: -8px 0 10px 0 rgb(0 0 0 / 5%);
          z-index: 2;
        }
      }
      /* Explicitly relax sticky for grids without actions */
      .noActionGrid & {
        &:last-child {
          position: relative !important;
          right: auto !important;
          padding-left: 20px !important;
        }
      }
      &:first-child {
        padding-left: 16px;
      }
    }
    td {
      padding: 8px;
      vertical-align: text-top;
      font-weight: 400;
      white-space: pre;
      .editDeleteAction {
        display: flex;
        justify-content: flex-start;
      }
      .textBold {
        font-weight: 600;
      }
      /* Base padding for last cell in every row (keeps compiled selector .CHbKm tr td:last-child) */
      &:last-child {
        padding-left: 20px;
      }
      /* Make body Actions sticky only when table has action column */
      .hasActionColumn & {
        &:last-child {    
          width: fit-content !important;
          width: 8% !important;
          max-width: 8% !important;
          min-width: 64px !important;
          padding-left: 20px;
          position: sticky;
          right: 0;
          background-color: white;
          border-bottom: 2px solid #EDEDED;
          box-shadow: -8px 0 10px 0 rgb(0 0 0 / 5%);
          z-index: 1;
          @-moz-document url-prefix() {
            margin-top: -30px !important;
          }
          button:first-child {
            margin-right: 8px !important;
          }
        }
      }
      .noActionGrid & {
        &:last-child {
          position: relative !important;
          right: auto !important;
          padding-left: 20px !important;
          box-shadow: none !important;
        }
      }
      &:first-child {
        padding-left: 16px;
      }
      &.amountCell {
        text-align: right;
      }
      /* Self service preview grid - no padding for no data row */
      .reportTemplatePreviewList &.withNoRow {
        padding-left: 0 !important;
      }
    }
    th, td {
      .gridCheckbox {
        background: rgb(255, 255, 255);
        border-style: solid;
        border-width: 1px;
        border-color: rgb(94, 96, 115);
        width: 28px;
        height: 28px;
        vertical-align: bottom;
        margin: 0px;
        cursor: pointer;
        border-radius: 0;
        appearance: none;
        &:hover, &:focus {
          border-width: 2px;
        }
        &:disabled {
          border-color: rgb(194, 195, 201);
          cursor: not-allowed !important;
          &:hover, &:focus {
            border-width: 1px;
            cursor: not-allowed !important;
          }
        }
        &:checked {
          border: 2px solid rgb(0, 167, 88);
          background: no-repeat ${colors.white} url(${checkmark}) 5px 7px;
        }
    }
  }  
  .templateList & {
    .actions-col {
      width: 112px !important;
      vertical-align: top;
    }
  }
  .generatedReports & {
    .actions-col {
      width: 92px !important;
      vertical-align: top;
    }
  }
`;

export const NoData = styled.div`
  padding: 0;
  font-size: 16px;
  color: ${colors.light_1_dark_navy}
`;
